import { getContentfulDeliveryConfig } from './config';

const CATALOG_TYPE_IDS = [
  'competency',
  'motivation',
  'personalityDimension',
  'teamStrength',
  'salesStrength',
  'adeptAspect',
  'adeptStyle',
  'assessmentInstrument',
  'report',
].join(',');

async function fetchPages(config, locale, extraParams, signal) {
  const items = [];
  let skip = 0;
  const limit = 100;

  while (true) {
    const url = new URL(
      `${config.cdn}/spaces/${config.spaceId}/environments/${config.environment}/entries`
    );
    url.searchParams.set('access_token', config.accessToken);
    url.searchParams.set('locale', locale);
    url.searchParams.set('limit', String(limit));
    url.searchParams.set('skip', String(skip));
    url.searchParams.set('include', '0');
    Object.entries(extraParams).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });

    const response = await fetch(url.toString(), { signal });
    if (!response.ok) {
      throw new Error(`Contentful CDA ${response.status}`);
    }
    const data = await response.json();
    const page = data.items || [];
    items.push(...page);
    if (page.length === 0 || items.length >= (data.total || 0)) break;
    skip += limit;
  }

  return items;
}

async function fetchOptionalCatalogType(config, locale, contentType, signal) {
  try {
    return await fetchPages(config, locale, { content_type: contentType }, signal);
  } catch (error) {
    if (typeof console !== 'undefined') {
      console.warn(`Contentful catalog ${contentType} skipped.`, error);
    }
    return [];
  }
}

export async function fetchContentfulEntries(contentfulLocale, signal) {
  const config = getContentfulDeliveryConfig();
  if (!config) return null;

  const [copyBundles, catalogs, jobIndustries, targetProfiles] = await Promise.all([
    fetchPages(
      config,
      contentfulLocale,
      {
        content_type: 'copyBundle',
        'fields.app': 'corporate',
      },
      signal
    ),
    fetchPages(
      config,
      contentfulLocale,
      {
        'sys.contentType.sys.id[in]': CATALOG_TYPE_IDS,
      },
      signal
    ),
    fetchOptionalCatalogType(config, contentfulLocale, 'jobIndustry', signal),
    fetchOptionalCatalogType(config, contentfulLocale, 'targetProfile', signal),
  ]);

  return { copyBundles, catalogs: [...catalogs, ...jobIndustries, ...targetProfiles] };
}
